import { Injectable } from '@angular/core';
import { AbstractControl } from '@angular/forms';
import { ItemBaseModel, ItemStateType } from '@libs/form/models';
import { ConditionEvaluator } from './evaluator';
import { EnabledStateHandler, StateHandler, VisibleStateHandler } from './handler';

@Injectable()
export class StateHandlerFactory {
  public create(state: ItemStateType, evaluator: ConditionEvaluator, item: ItemBaseModel, control?: AbstractControl): StateHandler | undefined {
    let handler: StateHandler;

    switch (state) {
      case 'enabled':
        handler = new EnabledStateHandler(evaluator, item, control);

        break;
      case 'visible':
        handler = new VisibleStateHandler(evaluator, item, control);

        break;
    }

    return handler;
  }
}
